import { Employee } from '../api/models/employee';
import { crateQueryResponseContextFor } from 'components/table/contexts/query-response';

const employeeQueryResponseContext = crateQueryResponseContextFor<Employee>();

export { employeeQueryResponseContext };
